import { formatNumber } from '../helpers/number-formatter';

export default (product, variant) => {
    return !!variant && !!product
        ? {
              item_id: variant['sku'],
              item_name: product['name'],
              price: formatNumber(variant['price']),
              affiliation: location.hostname || '',
              discount: formatNumber(variant['uvp'] ? parseFloat(variant['uvp']) - parseFloat(variant['price']) : null),
              item_brand: product['brand'],
              item_variant: `${variant['specCombinationKey']}`,
              quantity: 1,
              // color: variant.specs.FARB.value,
              // priceGross: '',
              // category: variant['productLine'], TODO
              // availability: TODO, but probaly not needed here.
          }
        : {};
};
